import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.policy.simulator');
@Component({
    selector: 'wiz-page-policy-simulator',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.policy.simulator/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f4f6f8;
}`],
})
export class PagePolicySimulatorComponent { }

export default PagePolicySimulatorComponent;